import { render, staticRenderFns } from "./OrderCusDetail.vue?vue&type=template&id=657149ce"
import script from "./OrderCusDetail.vue?vue&type=script&lang=js"
export * from "./OrderCusDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports